// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + ({"262":"UpgradeModal","510":"Restricted","614":"Status","681":"Checkout","842":"List"}[chunkId] || chunkId) + ".chunk.min.js";
};